import { render, staticRenderFns } from "./ConfirmModal.vue?vue&type=template&id=0252a24a"
import script from "./ConfirmModal.vue?vue&type=script&lang=js"
export * from "./ConfirmModal.vue?vue&type=script&lang=js"
import style0 from "./ConfirmModal.vue?vue&type=style&index=0&id=0252a24a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports